import type { AccessibilityProps } from 'react-native'
import * as Comp from './modal-title.styles'

interface THeaderLabelProps extends AccessibilityProps {
  children: string
  testID?: string
}

export function ModalTitle({ children, testID }: THeaderLabelProps) {
  const componentProperties = {
    testID,
  }

  return (
    <Comp.Label numberOfLines={1} {...componentProperties}>
      {children}
    </Comp.Label>
  )
}
